import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IndicatorState } from '../../consent-requests/consent-requests.component';

@Component({
    selector: 'consent-approval-indicator',
    templateUrl: './approval-indicator.component.html',
    styleUrls: ['./approval-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApprovalIndicatorComponent {
  @Input() indicatorState: IndicatorState;

  IndicatorState = IndicatorState;
}
